import React from 'react';

import Loading from '../components/Loading/Loading';

const Loader = () => {
  return <Loading type={Loading.TYPE.MATERIAL} name={'linear'} />;
};

export default Loader;
